import { Link } from "react-router-dom";
import { SignUpForm } from "@/components/auth/sign-up-form";

export function SignUpPage() {
  return (
    <main className="flex min-h-screen items-center justify-center bg-bg px-4">
      <div className="w-full max-w-sm">
        <div className="mb-8 text-center">
          <h1 className="text-2xl font-bold text-foreground">ceo-cmd</h1>
          <p className="mt-1 text-sm text-muted-foreground">
            Create your command centre account
          </p>
        </div>

        <div className="rounded-lg border border-border bg-card p-6">
          <SignUpForm />
        </div>

        <p className="mt-4 text-center text-sm text-muted-foreground">
          Already have an account?{" "}
          <Link
            to="/signin"
            className="font-medium text-brand hover:underline"
          >
            Sign in
          </Link>
        </p>
      </div>
    </main>
  );
}
